import React, { PureComponent } from 'react';
import { Grid, Typography } from '@material-ui/core';

import Footer from 'common/footer/footer';
import TopBar from 'common/topBar/topBar';

import './privacyPolicy.scss';

class PrivacyPolicy extends PureComponent {
  render() {
    return (
      <>
        <TopBar />
        <Grid container justify="center">
          <Grid item xs={8} className="sr-privacy-policy">
            <Typography className="sr-privacy-policy-title">
              Privacy Policy
            </Typography>
            <Typography className="sr-privacy-policy-body">
              We at Senseloaf (“Senseloaf”, “We”. “our” or “us”) believe
              protecting users’ (“User”, “you” or “your”) private information is
              our topmost priority.This privacy policy (“Privacy Policy”,
              “Policy”) describes the manner in which Sensloaf collects, stores,
              uses, discloses, alters your personally identifiable information,
              the measures we take to protect your personally identifiable
              information (“PII”) and your choices and rights regarding our use
              of PII collected during your usage of our Site and the Services
              provided by Senseloaf. Any capitalized terms used but not defined
              in this Privacy Policy shall have the meaning ascribed to such
              term in the Terms of Service.
            </Typography>
            <br />
            <Typography className="sr-privacy-policy-body">
              This Policy covers the information collected through our website,
              mobile application or any of Our platforms (“Site”), collected to
              better serve you and assist you with your recruitment needs. We
              are the sole owner of the information collected through our Site,
              and you hereby by registering for our Services have provided a
              specific, unambiguous and informed consent to Senseloaf for
              collecting your PII and any other information as per the terms and
              manner specified in this Privacy Policy and the Terms of Service.
              You hereby acknowledge and agree that before registering to our
              Services you have read the terms of this Privacy Policy, and any
              other applicable terms that may be required as a condition of your
              usage of our Services.
            </Typography>
            <br />
            <Typography className="sr-privacy-policy-body">
              The purpose of this Policy is to ensure that:
            </Typography>
            <ol>
              <Typography component="li" className="sr-privacy-policy-body">
                You are aware of and have complete control over what PII you
                provide to Senseloaf, and the how the same is being used by
                Senseloaf while providing you with our Services;
              </Typography>
              <Typography component="li" className="sr-privacy-policy-body">
                You are at all times aware of the rights available to you with
                respect to your PII;
              </Typography>
              <Typography component="li" className="sr-privacy-policy-body">
                The information provided by you on the Site is processed,
                stored, and used in accordance with the applicable laws,
                including with respect to maintaining appropriate data
                protection and privacy infrastructure.
              </Typography>
            </ol>
            <br />
            <Typography className="sr-privacy-policy-body">
              By registering for, using or accessing our Services, you
              acknowledge that this Privacy Policy is part of our Terms of
              Service, and agree to the practices described in this Policy.
              Please read the Policy carefully. If you do not agree to be bound
              by such terms and conditions, you are not authorized to access or
              use the Services.
            </Typography>
            <br />
            <ol className="nested-ol">
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Collection of your Personal Information
              </Typography>
              <Typography className="sr-privacy-policy-body">
                When you contact us or interact with the Site, we may collect
                Personal Data that, alone or in combination with other
                information, could be used to identify you as follows:
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Customer Account and Inquiries: If you are a Customer or
                prospective Customer (or a representative or employee), we
                collect and process your Personal Data when you (i) visit the
                Site or make a request to receive information about our
                Services, including to book a demo, (ii) contact our sales team
                or customer support team, and (iii) sign up for an Senseloaf
                account and use the Services. The Personal Data we collect may
                include your first and last name, job title, company name, email
                address, mailing address, password to access your Customer
                portal, payment and billing information, phone number, country
                location.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                <Typography className="sr-privacy-policy-body-bold">
                  Job Applicants:
                </Typography>{' '}
                If you are applying for a job with us, we collect and process
                your job application information that may contain Personal Data
                such as those in your resume.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                <Typography className="sr-privacy-policy-body-bold">
                  Information We Collect Through Our Social Media Pages:
                </Typography>{' '}
                We have pages on social media sites like Facebook, Twitter, and
                LinkedIn (“Social Media Pages”). We may collect Personal Data
                from you when you interact with our Social Media Pages, such as
                the Facebook “like” button, the “Tweet” button and other sharing
                widgets (“Social Media Features”). You may be given the option
                by such Social Media Features to post information about your
                activities on a website to a profile page of yours that is
                provided by a third party social media network in order to share
                with others within your network. Social Media Features are
                either hosted by the respective social media network or hosted
                directly on our website. To the extent the Social Media Features
                are hosted by the respective social media networks, the latter
                may receive information that you have visited our website from
                your IP address. If you are logged into your social media
                account, it is possible that the respective social media network
                can link your visit to our website with your social media
                profile.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Your interactions with Social Media Features are governed by the
                privacy policies of the companies providing the relevant Social
                Media Features.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Information We Receive From Your Use of the Site: When you
                visit, use and interact with the Site, we may receive certain
                information about your visit, use or interactions. For example,
                we may monitor the number of people that visit our Site, peak
                hours of visits, which page(s) are visited on our Site, the
                domains our visitors come from (e.g., google.com, yahoo.com,
                etc.), and which browsers people use to access and visit our
                Site (e.g., Firefox, Microsoft Internet Explorer, etc.), broad
                geographical information, and Site-navigation pattern. In
                particular, the following information is created and
                automatically logged in our systems:
              </Typography>
              <br />
              <ul>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Log data:
                  </Typography>{' '}
                  Information (“log data”) that your browser automatically sends
                  whenever you visit the Site. Log data includes your Internet
                  Protocol (“IP”) address (so we understand which country you
                  are connecting from when you visit the Site), browser type and
                  settings, the date and time of your request, and how you
                  interacted with the Site.
                </Typography>
                <br />
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Device information:
                  </Typography>{' '}
                  Includes name of the device, operating system, and browser you
                  are using. Information collected may depend on the type of
                  device you use and its settings.
                </Typography>
                <br />

                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Usage Information:
                  </Typography>{' '}
                  We collect information about how you use our Site, such as the
                  types of content that you view or engage with, the features
                  you use, the actions you take, and the time, frequency and
                  duration of your activities
                </Typography>
              </ul>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Use of your Personal Information
              </Typography>
              <Typography className="sr-privacy-policy-body">
                We use Personal Data collected via the Site for the following
                purposes:
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                <Typography className="sr-privacy-policy-body-bold">
                  As necessary for certain legitimate business interests
                </Typography>
                , which include the following:
              </Typography>
              <br />
              <ul>
                <Typography component="li" className="sr-privacy-policy-body">
                  To respond to inquiries, comments, feedback or questions;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  To find employment opportunities for you as job applicants;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  To send administrative or account related information to you,
                  for example, information about the Site or Services, and
                  changes to our terms, conditions, and policies.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  To analyze Site usage and provide, maintain and improve the
                  content and functionality of the Site. For example, we
                  regularly fix bugs and user experience issues.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  To conduct analytics to inform our marketing strategy and
                  enable us to enhance and personalize the experience we offer
                  to our customers;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  To prevent fraud, criminal activity, or misuses of our Site
                  and to ensure the security of our IT systems, architecture and
                  networks;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  To comply with legal obligations and legal process and to
                  protect our rights, privacy, safety or property, and/or that
                  of our affiliates, customers, or other third parties; and
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  If you ask us to delete your data and we are required to
                  fulfill your request, we will keep basic data to maintain a
                  record of your request, our response to it and use that data
                  to prevent further unwanted processing.
                </Typography>
              </ul>
              <br />
              <Typography className="sr-privacy-policy-body">
                <Typography className="sr-privacy-policy-body-bold">
                  Marketing.{' '}
                </Typography>{' '}
                We may contact you to tell you about services we believe will be
                of interest to you. For instance, if you elect to provide your
                email or telephone number, we may use that information to send
                you special offers. Where required by applicable law, we will
                obtain your consent prior to sending you marketing
                communications. You may opt out of receiving emails by following
                the instructions contained in each promotional email we send
                you. You can also control the marketing messages you receive by
                updating your settings. In addition, if at any time you do not
                wish to receive future marketing communications, please contact
                us. If you unsubscribe from our marketing lists, you will no
                longer receive marketing communications but we will continue to
                contact you regarding our Site and Services and to respond to
                your requests.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Sharing Information with Third Parties
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                We do not sell or otherwise share any information about you or
                provided by you, except as described in this Policy. We may
                share your personal information to our affiliates and third
                parties to help us provide and improve our Services. Access to
                only as much information is made available as is reasonably
                necessary or required by law. These third parties are not
                authorized by us to use or disclose the information except as
                necessary to perform services on our behalf.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In case of restructuring, reorganization, dissolution, sale,
                merger with or being acquired by any other entity, we reserve
                the right to transfer or share any information we have about you
                with such entity and the use of the information thus shared
                shall be governed by the Privacy Policy of that entity.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Unless otherwise provided in this Privacy Policy, we shall not
                share any of your information with any third party except for
                when required in relation to prevention of illegal activities or
                suspected fraud or when required by law to do so. We also
                reserve the right to disclose or share user information in
                special cases, for example, when such disclosure is necessary to
                identify, contact or bring legal action against someone who may
                be infringing (or threatening to infringe) or who may otherwise
                be causing injury to or interference with (either intentionally
                or unintentionally), our title, rights, interests or property,
                or those of other Site users, or of anyone else who could be
                harmed by such activities.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In addition to any third-party service providers who, subject to
                your prior consent, we may share your information and/or your
                PII with third party service providers (as mentioned in the
                Terms of Service), we may disclose any information provided by
                you on the Site as may be deemed to be necessary or appropriate:
                (a) under applicable law, including laws outside your country of
                residence; (b) to comply with legal process; (c) to respond to
                requests from public and government authorities including public
                and government authorities outside your country of residence;
                (d) to enforce our Terms of Service; or (e) to allow us to
                pursue available remedies or limit the damages that we may
                sustain.
              </Typography>
              <Typography className="sr-privacy-policy-body">
                By agreeing to this Policy, you also explicitly understand and
                consent to the fact that we may share your PII with other
                corporate entities and affiliates only for the purposes of:
              </Typography>
              <br />
              <ol>
                <Typography component="li" className="sr-privacy-policy-body">
                  Cloud based web hosting and server services;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  Using their assistance to detect and prevent identity theft,
                  fraud and other potentially illegal acts; or
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  Correlating related or multiple accounts to prevent abuse of
                  Our Services;
                </Typography>
              </ol>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Third Party Sites:
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Our Services may contain a link to third party content and
                services to offer you the benefit of products and services which
                we do not offer. The access to a third party link provided by
                our Services does not imply endorsement of the linked site by us
                or by our affiliates. Any information that you provide through
                the links to any third party sites will be subject to the
                privacy policy of that site, and you should read the relevant
                privacy policy for those third party sites before responding to
                any offers, services, or submitting any data.{' '}
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                We are also not responsible for the privacy practices and data
                collection policies followed by any third party sites that are
                not affiliated with Senseloaf, including any information you may
                submit or disclose to other organizations through or in
                connection with the links provided through our Services.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Automatically Collected Information
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Information about your computer hardware and software may be
                automatically collected by SenseLoaf. This information can
                include: your IP address, browser type, domain names, access
                times and referring website addresses. This information is used
                for the operation of the service, to maintain quality of the
                service, and to provide general statistics regarding use of the
                SenseLoaf website.{' '}
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Security
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                We implement reasonable technical and organizational measures to
                protect Personal Data from loss, misuse, and unauthorized
                access, disclosure, alteration or destruction. For example, we
                use available technology and other techniques to implement
                systems like firewalls and/or encryption. However, no Internet
                or e-mail transmission is ever fully secure or error free. In
                particular, e-mail sent to or from us may not be secure.
                Therefore, you should take special care in deciding what
                information you send to us via the Services. Please keep this in
                mind when disclosing any Personal Data to Senseloaf via the
                Internet. In addition, we are not responsible for circumvention
                of any privacy settings or security measures contained on the
                Site, the Services, or third party websites.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Your Rights and Choices
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                You may also opt out of receiving promotional communications
                from Senseloaf or opt-out of sharing your personal information
                with third parties by emailing us about the same.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Once you start using our services, you will have the right, at
                any time, to require us to do any of the following with respect
                to your PII:
              </Typography>
              <br />
              <ol>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to be informed:
                  </Typography>{' '}
                  Company is publishing this Privacy Policy to keep you informed
                  as to what we do with your personal information. We strive to
                  be transparent about how we use your data;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to access:
                  </Typography>{' '}
                  You have the right to access certain personal information we
                  maintain about you and obtain a copy of that information;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to erasure:
                  </Typography>{' '}
                  Delete/erase all PII pertaining to you that we may have on our
                  systems. This includes deleting your account and all PII that
                  we may have pertaining to you in the Data Trail. This
                  provision will not apply to any data or PII that we may need
                  to retain pursuant to any applicable law or any
                  request/requirement of a public/government body, whether in
                  your country of residence or not;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to rectification:
                  </Typography>{' '}
                  Rectify, modify, or alter any of your PII, if you have
                  identified any mistake, error or inaccuracy in the same. This
                  also covers situations where, for example, you have started
                  using a new/different email account for the purposes of
                  signing in to Senseloaf’s Service;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to export data and Right to be informed:
                  </Typography>{' '}
                  Export and provide you with a copy of all your data, including
                  your PII, that we may have on our servers. This includes all
                  data and server logs pertaining to your activities and
                  behavior on the Site as well as the Services;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to restrict processing:
                  </Typography>{' '}
                  You have the right to ask Senseloaf to restrict how we process
                  your Data. This means we are permitted to store the data but
                  not further process it. We keep just enough data to make sure
                  we respect your request in the future;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to object:
                  </Typography>{' '}
                  You has the right to object to Senseloaf processing your data
                  even if it is based on our legitimate interests, the exercise
                  of official authority, direct marketing (including data
                  aggregation), and processing for the purposeless of
                  statistics;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Opt out from receiving promotional messages:
                  </Typography>{' '}
                  You may also opt out of receiving promotional communications
                  from Senseloaf or opt-out of sharing your personal information
                  with third parties by emailing us about the same;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Right to withdraw consent:
                  </Typography>{' '}
                  If you have given us your consent to process your data but
                  change your mind later, you have the right to withdraw your
                  consent at any time, and Senseloaf must stop processing your
                  data;
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  <Typography className="sr-privacy-policy-body-bold">
                    Choice/Opt-Out:
                  </Typography>{' '}
                  As stated previously, we provide all users with the option and
                  choice of opting-out of receiving certain third-party services
                  and/or the in general, at any time.
                </Typography>
              </ol>
              <br />
              <Typography className="sr-privacy-policy-body">
                We will make all commercially reasonable best efforts to comply
                with all of the above requests (when received) as soon as
                possible. If you wish to exercise any of your above rights,
                kindly send an email to{' '}
                <Typography className="sr-privacy-policy-body-bold">
                  team@senseloaf.com
                </Typography>
                .
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In case of cancellation or deletion of your account, kindly note
                that certain personal information may be retained by us,
                wherever required or authorized by applicable law. If your
                account is managed by an administrator, that account
                administrator may have control with regards to how your account
                information is retained and deleted. Please remember any content
                that has been shared by you or submitted to any third-party link
                provided via the Services may continue to be available to third
                parties. If you wish to exercise your rights and take necessary
                actions with respect to your rights as mentioned above please
                write to our grievance redressal officer at{' '}
                <Typography className="sr-privacy-policy-body-bold">
                  team@senseloaf.com
                </Typography>
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Information for California Residents
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In accordance with the California Consumer Privacy Act (“CCPA”),
                this section is intended to inform California residents of (1)
                the Personal Information that we collect and how we disclose
                that information, and (2) the privacy rights California
                residents may have relating to their Personal Information and
                how those rights can be exercised. As used in this section
                “Personal Information” means information maintained in a manner
                that identifies, relates to, describes, is reasonably capable of
                being associated with, or could reasonably be linked, directly
                or indirectly, with a particular California resident or
                household, as further defined by CCPA.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                8.1 Personal Information Collection and Disclosure
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                The following disclosures are intended to provide additional
                information about (1) the categories of Personal Information we
                collect, and (2) how and to whom we disclose that Personal
                Information. Nothing in this section limits our ability to use
                or disclose information as described elsewhere in this Privacy
                Policy.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                8.2 Categories of Personal Information Collected
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In the past 12 months, we have collected the following
                categories of Personal Information, as described in greater
                detail above:
              </Typography>
              <br />
              <ul>
                <Typography component="li" className="sr-privacy-policy-body">
                  Identification Information, such as name, phone number,
                  address, and email address.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  Employment and Professional Information, such as job titles,
                  companies, schools attended, job history and other information
                  included in resumes, projects worked on, skills, and other
                  employment information uploaded by Customers.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  Online Activity Information, such as IP address, device
                  information, browser type and settings, the date and time of
                  your request, how you interacted with the Site and Services,
                  other usage information, and information automatically
                  collected using cookies and other technologies.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  Commercial Information, such as purchase, payment, and billing
                  information.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  Inferences made by machine learning to the extent associated
                  with a person and job positions, such as likely skills and fit
                  for a particular job opportunity.
                </Typography>
              </ul>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                8.3 Categories of Personal Information Sold or Disclosed for a
                Business Purpose
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Senseloaf does not make your Personal Information available for
                purchase or otherwise share your information in exchange for
                monetary compensation.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In the past 12 months, we have disclosed for a business purpose
                all of the above categories of Personal Information to our
                Customers as a part of the Services, to our vendors or service
                providers, and as otherwise described in the Sharing and
                Disclosure sections above for the Site and the Services.
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In particular, in the last 12 months, if you have visited our
                Site, we may have shared your Identification Information and
                Online Activity Information with advertising partners to match
                and serve our targeted advertisements on third party websites.
                Also, in the last 12 months, we may have shared Identification
                Information and Employment and Professional Information obtained
                from public and commercial sources with our Customers as a part
                of the Services in order to ensure candidate’s job profiles are
                up-to-date. See below for information about how to opt out of
                the sharing of your Personal Information for these purposes.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                8.4 California Privacy Rights
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                To the extent provided for by the CCPA and subject to applicable
                exceptions and exclusions, California residents have the
                following privacy rights in relation to the Personal Information
                we collect:
              </Typography>
              <br />
              <ul>
                <Typography component="li" className="sr-privacy-policy-body">
                  The right to know what Personal Information we have collected
                  and how we have used and disclosed that Personal Information.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  The right to request deletion of your Personal Information.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  The right to opt out of the sale of your Personal Information.
                </Typography>
                <Typography component="li" className="sr-privacy-policy-body">
                  The right to non-discrimination for the exercise of any of
                  your privacy rights.
                </Typography>
              </ul>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                8.5 Exercising Your Rights
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                California residents can exercise the above privacy rights by
                contacting us at the{' '}
                <Typography className="sr-privacy-policy-body-bold">
                  team@senseloaf.com
                </Typography>
                , or calling us at{' '}
                <Typography className="sr-privacy-policy-body-bold">
                  +1 (352) 872-8926
                </Typography>
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                8.6 Verification
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                In order to protect your Personal Information from unauthorized
                access or deletion, we may require you to verify your
                credentials before you can submit a request to know or delete
                Personal Information. If you do not have an account with us, or
                if we suspect fraudulent or malicious activity, we may ask you
                to provide additional Personal Information for verification. If
                we cannot verify your identity, we will not provide or delete
                your Personal Information.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                8.7 Authorized Agents
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                You may submit a request to know or a request to delete your
                Personal Information through an authorized agent. If you do so,
                we may require the agent to present signed written permission to
                act on your behalf and you may also be required to independently
                verify your identity with us and confirm that you have provided
                the agent permission to submit the request.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title"
              >
                Other Information:
              </Typography>
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                9.1 Children
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                The Site and the Services are not directed to children who are
                under the age of 16. Senseloaf does not knowingly collect
                Personal Data from children under the age of 16. If you have
                reason to believe that a child under the age of 16 has provided
                Personal Data to Senseloaf through the Site or Services please
                contact us and we will endeavor to delete that information from
                our databases.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                9.2 Online Tracking and Do-Not-Track Signals
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                We and our third party service providers may use cookies or
                other tracking technologies to collect information about your
                browsing activities over time and across different websites
                following your use of the Site and use that information to send
                targeted advertisements. Our Site currently does not respond to
                Web browser “Do Not Track” (“DNT”) signals and operates as
                described in this Privacy Policy whether or not a Web browser
                DNT signal is received. If we do respond to DNT signals in the
                future, we will update this Privacy Policy to describe how we do
                so.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                9.3 Changes to the Privacy Policy
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                The Site, the Services, and our business may change from time to
                time. As a result we may change this Privacy Policy at any time.
                When we do, we will post an updated version on this page, unless
                another type of notice is required by the applicable law. By
                continuing to use the Site or Services or providing us with
                Personal Data after we have posted an updated Privacy Policy, or
                notified you if applicable, you consent to the revised Privacy
                Policy and practices described in it.
              </Typography>
              <br />
              <br />
              <Typography
                component="li"
                className="sr-privacy-policy-list-title-nested"
              >
                9.4 Contact Us
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                If you have any questions about our Privacy Policy or the
                information practices of the Site, would like to exercise Your
                Rights, or need to access this Privacy Policy in a different
                format, please feel free to contact us at{' '}
                <Typography className="sr-privacy-policy-body-bold">
                  team@senseloaf.com
                </Typography>{' '}
                or at the mailing address below. And for any opt-out request,
                please describe your request and send it to{' '}
                <Typography className="sr-privacy-policy-body-bold">
                  team@senseloaf.com
                </Typography>
                .
              </Typography>
              <br />
              <Typography className="sr-privacy-policy-body">
                Senseloaf Technologies Private Limited,
              </Typography>
              <Typography className="sr-privacy-policy-body">
                Kudlu Gate, Bangalore
              </Typography>
            </ol>
          </Grid>
        </Grid>
        <Footer />
      </>
    );
  }
}

export default PrivacyPolicy;
